import React from 'react'
import DatePicker, { ReactDatePickerProps } from 'react-datepicker'
import MaskedInput from 'react-text-mask'
import { TextInput, TextInputTheme } from '../TextInput/TextInput'
import style from './Datepicker.module.css'

export interface DatepickerProps {
  theme?: TextInputTheme
  selectedDate?: Date | null
  datePickerProps?: Partial<ReactDatePickerProps>
  renderFooter?: () => React.ReactNode
  onChange: (date: Date) => void
}

export function Datepicker({
  onChange,
  theme,
  selectedDate,
  datePickerProps
}: DatepickerProps) {
  const handleDateInputChange = (date: Date) => {
    onChange(date)
  }

  return (
    // @ts-ignore
    <DatePicker
      {...datePickerProps}
      className={style.root}
      onChange={handleDateInputChange}
      dateFormat={'dd.MM.yyyy'}
      selected={selectedDate}
      customInput={
        //@ts-ignore
        <MaskedInput
          placeholder='__.__.____'
          mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]}
          type='text'
          render={(
            ref: (inputElement: HTMLElement) => void,
            props: {
              onChange: (event: React.ChangeEvent<HTMLElement>) => void
              onBlur: (event: React.FocusEvent<HTMLElement>) => void
              defaultValue: string | undefined
            }
          ) => (
            // TODO: check inputRef works
            <TextInput
              theme={theme}
              // @ts-ignore
              inputRef={ref}
              type='text'
              placeholder='__.__.____'
              {...props}
            />
          )}
        />
      }
    />
  )
}

export default Datepicker
